<template>
  <div class="popup__item points__item" :class="`points__item--${offerIndex}`">
    <h4>{{ $t(`points.name_${offerIndex}`) }}</h4>
    <div class="points__count">
      <p>{{ $t("points.amount") }}</p>
      <div class="amount">
        <i class="icon icon-paid-points"></i>
        <span>{{ offer.amount }}</span>
      </div>
    </div>

    <img class="points__image" :src="getPointsImage" :alt="$t(`points.name_${offerIndex}`)" />

    <p class="points__price-label">{{ $t("points.price") }}</p>
    <div class="popup__price points__price">
      <div :class="{ sale: offer.is_discount }">
        <span v-html="currency.symbol"></span>
        <span>{{ getFinalCost }}</span>
        <span v-if="offer.is_discount" class="old">{{ getCost }}</span>
      </div>
    </div>

    <div class="popup__button gtm-button gtm-balance-popup">
      <button @click="setActive">
        {{ $t("common.buy") }}
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name: "PointsItem",
  props: {
    offerIndex: {
      requited: true,
      type: Number,
    },
    activeIndex: {
      requited: true,
      type: Number,
    },
    offer: {
      requited: true,
      type: Object,
    },
    currency: {
      requited: true,
      type: Object,
    },
  },
  computed: {
    isActive() {
      return this.offerIndex === this.activeIndex;
    },
    getCost() {
      return this.offer[`cost_${this.currency.id}`];
    },
    getSaleCost() {
      return this.offer[`discount_cost_${this.currency.id}`];
    },
    getFinalCost() {
      return this.offer.is_discount ? this.getSaleCost : this.getCost;
    },
    getPointsImage() {
      return require(`@/assets/points/images/points_${this.offerIndex}.png`);
    },
  },
  methods: {
    setActive() {
      this.$emit("setActiveOffer", this.offerIndex);
    },
  },
};
</script>
